const countryCodeArray = [
  {
    label: "Afghanistan",
    value: "+93",
    code: "AF",
  },
  {
    label: "Aland Islands",
    value: "+358",
    code: "AX",
  },
  {
    label: "Albania",
    value: "+355",
    code: "AL",
  },
  {
    label: "Algeria",
    value: "+213",
    code: "DZ",
  },
  {
    label: "AmericanSamoa",
    value: "+1684",
    code: "AS",
  },
  {
    label: "Andorra",
    value: "+376",
    code: "AD",
  },
  {
    label: "Angola",
    value: "+244",
    code: "AO",
  },
  {
    label: "Anguilla",
    value: "+1264",
    code: "AI",
  },
  {
    label: "Antarctica",
    value: "+672",
    code: "AQ",
  },
  {
    label: "Antigua and Barbuda",
    value: "+1268",
    code: "AG",
  },
  {
    label: "Argentina",
    value: "+54",
    code: "AR",
  },
  {
    label: "Armenia",
    value: "+374",
    code: "AM",
  },
  {
    label: "Aruba",
    value: "+297",
    code: "AW",
  },
  {
    label: "Australia",
    value: "+61",
    code: "AU",
  },
  {
    label: "Austria",
    value: "+43",
    code: "AT",
  },
  {
    label: "Azerbaijan",
    value: "+994",
    code: "AZ",
  },
  {
    label: "Bahamas",
    value: "+1242",
    code: "BS",
  },
  {
    label: "Bahrain",
    value: "+973",
    code: "BH",
  },
  {
    label: "Bangladesh",
    value: "+880",
    code: "BD",
  },
  {
    label: "Barbados",
    value: "+1246",
    code: "BB",
  },
  {
    label: "Belarus",
    value: "+375",
    code: "BY",
  },
  {
    label: "Belgium",
    value: "+32",
    code: "BE",
  },
  {
    label: "Belize",
    value: "+501",
    code: "BZ",
  },
  {
    label: "Benin",
    value: "+229",
    code: "BJ",
  },
  {
    label: "Bermuda",
    value: "+1441",
    code: "BM",
  },
  {
    label: "Bhutan",
    value: "+975",
    code: "BT",
  },
  {
    label: "Bolivia, Plurinational State of",
    value: "+591",
    code: "BO",
  },
  {
    label: "Bosnia and Herzegovina",
    value: "+387",
    code: "BA",
  },
  {
    label: "Botswana",
    value: "+267",
    code: "BW",
  },
  {
    label: "Brazil",
    value: "+55",
    code: "BR",
  },
  {
    label: "British Indian Ocean Territory",
    value: "+246",
    code: "IO",
  },
  {
    label: "Brunei Darussalam",
    value: "+673",
    code: "BN",
  },
  {
    label: "Bulgaria",
    value: "+359",
    code: "BG",
  },
  {
    label: "Burkina Faso",
    value: "+226",
    code: "BF",
  },
  {
    label: "Burundi",
    value: "+257",
    code: "BI",
  },
  {
    label: "Cambodia",
    value: "+855",
    code: "KH",
  },
  {
    label: "Cameroon",
    value: "+237",
    code: "CM",
  },
  {
    label: "Canada",
    value: "+1",
    code: "CA",
  },
  {
    label: "Cape Verde",
    value: "+238",
    code: "CV",
  },
  {
    label: "Cayman Islands",
    value: "+ 345",
    code: "KY",
  },
  {
    label: "Central African Republic",
    value: "+236",
    code: "CF",
  },
  {
    label: "Chad",
    value: "+235",
    code: "TD",
  },
  {
    label: "Chile",
    value: "+56",
    code: "CL",
  },
  {
    label: "China",
    value: "+86",
    code: "CN",
  },
  {
    label: "Christmas Island",
    value: "+61",
    code: "CX",
  },
  {
    label: "Cocos (Keeling) Islands",
    value: "+61",
    code: "CC",
  },
  {
    label: "Colombia",
    value: "+57",
    code: "CO",
  },
  {
    label: "Comoros",
    value: "+269",
    code: "KM",
  },
  {
    label: "Congo",
    value: "+242",
    code: "CG",
  },
  {
    label: "Congo, The Democratic Republic of the Congo",
    value: "+243",
    code: "CD",
  },
  {
    label: "Cook Islands",
    value: "+682",
    code: "CK",
  },
  {
    label: "Costa Rica",
    value: "+506",
    code: "CR",
  },
  {
    label: "Cote d'Ivoire",
    value: "+225",
    code: "CI",
  },
  {
    label: "Croatia",
    value: "+385",
    code: "HR",
  },
  {
    label: "Cuba",
    value: "+53",
    code: "CU",
  },
  {
    label: "Cyprus",
    value: "+357",
    code: "CY",
  },
  {
    label: "Czech Republic",
    value: "+420",
    code: "CZ",
  },
  {
    label: "Denmark",
    value: "+45",
    code: "DK",
  },
  {
    label: "Djibouti",
    value: "+253",
    code: "DJ",
  },
  {
    label: "Dominica",
    value: "+1767",
    code: "DM",
  },
  {
    label: "Dominican Republic",
    value: "+1849",
    code: "DO",
  },
  {
    label: "Ecuador",
    value: "+593",
    code: "EC",
  },
  {
    label: "Egypt",
    value: "+20",
    code: "EG",
  },
  {
    label: "El Salvador",
    value: "+503",
    code: "SV",
  },
  {
    label: "Equatorial Guinea",
    value: "+240",
    code: "GQ",
  },
  {
    label: "Eritrea",
    value: "+291",
    code: "ER",
  },
  {
    label: "Estonia",
    value: "+372",
    code: "EE",
  },
  {
    label: "Ethiopia",
    value: "+251",
    code: "ET",
  },
  {
    label: "Falkland Islands (Malvinas)",
    value: "+500",
    code: "FK",
  },
  {
    label: "Faroe Islands",
    value: "+298",
    code: "FO",
  },
  {
    label: "Fiji",
    value: "+679",
    code: "FJ",
  },
  {
    label: "Finland",
    value: "+358",
    code: "FI",
  },
  {
    label: "France",
    value: "+33",
    code: "FR",
  },
  {
    label: "French Guiana",
    value: "+594",
    code: "GF",
  },
  {
    label: "French Polynesia",
    value: "+689",
    code: "PF",
  },
  {
    label: "Gabon",
    value: "+241",
    code: "GA",
  },
  {
    label: "Gambia",
    value: "+220",
    code: "GM",
  },
  {
    label: "Georgia",
    value: "+995",
    code: "GE",
  },
  {
    label: "Germany",
    value: "+49",
    code: "DE",
  },
  {
    label: "Ghana",
    value: "+233",
    code: "GH",
  },
  {
    label: "Gibraltar",
    value: "+350",
    code: "GI",
  },
  {
    label: "Greece",
    value: "+30",
    code: "GR",
  },
  {
    label: "Greenland",
    value: "+299",
    code: "GL",
  },
  {
    label: "Grenada",
    value: "+1473",
    code: "GD",
  },
  {
    label: "Guadeloupe",
    value: "+590",
    code: "GP",
  },
  {
    label: "Guam",
    value: "+1671",
    code: "GU",
  },
  {
    label: "Guatemala",
    value: "+502",
    code: "GT",
  },
  {
    label: "Guernsey",
    value: "+44",
    code: "GG",
  },
  {
    label: "Guinea",
    value: "+224",
    code: "GN",
  },
  {
    label: "Guinea-Bissau",
    value: "+245",
    code: "GW",
  },
  {
    label: "Guyana",
    value: "+595",
    code: "GY",
  },
  {
    label: "Haiti",
    value: "+509",
    code: "HT",
  },
  {
    label: "Holy See (Vatican City State)",
    value: "+379",
    code: "VA",
  },
  {
    label: "Honduras",
    value: "+504",
    code: "HN",
  },
  {
    label: "Hong Kong",
    value: "+852",
    code: "HK",
  },
  {
    label: "Hungary",
    value: "+36",
    code: "HU",
  },
  {
    label: "Iceland",
    value: "+354",
    code: "IS",
  },
  {
    label: "India",
    value: "+91",
    code: "IN",
  },
  {
    label: "Indonesia",
    value: "+62",
    code: "ID",
  },
  {
    label: "Iran, Islamic Republic of Persian Gulf",
    value: "+98",
    code: "IR",
  },
  {
    label: "Iraq",
    value: "+964",
    code: "IQ",
  },
  {
    label: "Ireland",
    value: "+353",
    code: "IE",
  },
  {
    label: "Isle of Man",
    value: "+44",
    code: "IM",
  },
  {
    label: "Israel",
    value: "+972",
    code: "IL",
  },
  {
    label: "Italy",
    value: "+39",
    code: "IT",
  },
  {
    label: "Jamaica",
    value: "+1876",
    code: "JM",
  },
  {
    label: "Japan",
    value: "+81",
    code: "JP",
  },
  {
    label: "Jersey",
    value: "+44",
    code: "JE",
  },
  {
    label: "Jordan",
    value: "+962",
    code: "JO",
  },
  {
    label: "Kazakhstan",
    value: "+77",
    code: "KZ",
  },
  {
    label: "Kenya",
    value: "+254",
    code: "KE",
  },
  {
    label: "Kiribati",
    value: "+686",
    code: "KI",
  },
  {
    label: "Korea, Democratic People's Republic of Korea",
    value: "+850",
    code: "KP",
  },
  {
    label: "Korea, Republic of South Korea",
    value: "+82",
    code: "KR",
  },
  {
    label: "Kuwait",
    value: "+965",
    code: "KW",
  },
  {
    label: "Kyrgyzstan",
    value: "+996",
    code: "KG",
  },
  {
    label: "Laos",
    value: "+856",
    code: "LA",
  },
  {
    label: "Latvia",
    value: "+371",
    code: "LV",
  },
  {
    label: "Lebanon",
    value: "+961",
    code: "LB",
  },
  {
    label: "Lesotho",
    value: "+266",
    code: "LS",
  },
  {
    label: "Liberia",
    value: "+231",
    code: "LR",
  },
  {
    label: "Libyan Arab Jamahiriya",
    value: "+218",
    code: "LY",
  },
  {
    label: "Liechtenstein",
    value: "+423",
    code: "LI",
  },
  {
    label: "Lithuania",
    value: "+370",
    code: "LT",
  },
  {
    label: "Luxembourg",
    value: "+352",
    code: "LU",
  },
  {
    label: "Macao",
    value: "+853",
    code: "MO",
  },
  {
    label: "Macedonia",
    value: "+389",
    code: "MK",
  },
  {
    label: "Madagascar",
    value: "+261",
    code: "MG",
  },
  {
    label: "Malawi",
    value: "+265",
    code: "MW",
  },
  {
    label: "Malaysia",
    value: "+60",
    code: "MY",
  },
  {
    label: "Maldives",
    value: "+960",
    code: "MV",
  },
  {
    label: "Mali",
    value: "+223",
    code: "ML",
  },
  {
    label: "Malta",
    value: "+356",
    code: "MT",
  },
  {
    label: "Marshall Islands",
    value: "+692",
    code: "MH",
  },
  {
    label: "Martinique",
    value: "+596",
    code: "MQ",
  },
  {
    label: "Mauritania",
    value: "+222",
    code: "MR",
  },
  {
    label: "Mauritius",
    value: "+230",
    code: "MU",
  },
  {
    label: "Mayotte",
    value: "+262",
    code: "YT",
  },
  {
    label: "Mexico",
    value: "+52",
    code: "MX",
  },
  {
    label: "Micronesia, Federated States of Micronesia",
    value: "+691",
    code: "FM",
  },
  {
    label: "Moldova",
    value: "+373",
    code: "MD",
  },
  {
    label: "Monaco",
    value: "+377",
    code: "MC",
  },
  {
    label: "Mongolia",
    value: "+976",
    code: "MN",
  },
  {
    label: "Montenegro",
    value: "+382",
    code: "ME",
  },
  {
    label: "Montserrat",
    value: "+1664",
    code: "MS",
  },
  {
    label: "Morocco",
    value: "+212",
    code: "MA",
  },
  {
    label: "Mozambique",
    value: "+258",
    code: "MZ",
  },
  {
    label: "Myanmar",
    value: "+95",
    code: "MM",
  },
  {
    label: "Namibia",
    value: "+264",
    code: "NA",
  },
  {
    label: "Nauru",
    value: "+674",
    code: "NR",
  },
  {
    label: "Nepal",
    value: "+977",
    code: "NP",
  },
  {
    label: "Netherlands",
    value: "+31",
    code: "NL",
  },
  {
    label: "Netherlands Antilles",
    value: "+599",
    code: "AN",
  },
  {
    label: "New Caledonia",
    value: "+687",
    code: "NC",
  },
  {
    label: "New Zealand",
    value: "+64",
    code: "NZ",
  },
  {
    label: "Nicaragua",
    value: "+505",
    code: "NI",
  },
  {
    label: "Niger",
    value: "+227",
    code: "NE",
  },
  {
    label: "Nigeria",
    value: "+234",
    code: "NG",
  },
  {
    label: "Niue",
    value: "+683",
    code: "NU",
  },
  {
    label: "Norfolk Island",
    value: "+672",
    code: "NF",
  },
  {
    label: "Northern Mariana Islands",
    value: "+1670",
    code: "MP",
  },
  {
    label: "Norway",
    value: "+47",
    code: "NO",
  },
  {
    label: "Oman",
    value: "+968",
    code: "OM",
  },
  {
    label: "Pakistan",
    value: "+92",
    code: "PK",
  },
  {
    label: "Palau",
    value: "+680",
    code: "PW",
  },
  {
    label: "Palestinian Territory, Occupied",
    value: "+970",
    code: "PS",
  },
  {
    label: "Panama",
    value: "+507",
    code: "PA",
  },
  {
    label: "Papua New Guinea",
    value: "+675",
    code: "PG",
  },
  {
    label: "Paraguay",
    value: "+595",
    code: "PY",
  },
  {
    label: "Peru",
    value: "+51",
    code: "PE",
  },
  {
    label: "Philippines",
    value: "+63",
    code: "PH",
  },
  {
    label: "Pitcairn",
    value: "+872",
    code: "PN",
  },
  {
    label: "Poland",
    value: "+48",
    code: "PL",
  },
  {
    label: "Portugal",
    value: "+351",
    code: "PT",
  },
  {
    label: "Puerto Rico",
    value: "+1939",
    code: "PR",
  },
  {
    label: "Qatar",
    value: "+974",
    code: "QA",
  },
  {
    label: "Romania",
    value: "+40",
    code: "RO",
  },
  {
    label: "Russia",
    value: "+7",
    code: "RU",
  },
  {
    label: "Rwanda",
    value: "+250",
    code: "RW",
  },
  {
    label: "Reunion",
    value: "+262",
    code: "RE",
  },
  {
    label: "Saint Barthelemy",
    value: "+590",
    code: "BL",
  },
  {
    label: "Saint Helena, Ascension and Tristan Da Cunha",
    value: "+290",
    code: "SH",
  },
  {
    label: "Saint Kitts and Nevis",
    value: "+1869",
    code: "KN",
  },
  {
    label: "Saint Lucia",
    value: "+1758",
    code: "LC",
  },
  {
    label: "Saint Martin",
    value: "+590",
    code: "MF",
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "+508",
    code: "PM",
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "+1784",
    code: "VC",
  },
  {
    label: "Samoa",
    value: "+685",
    code: "WS",
  },
  {
    label: "San Marino",
    value: "+378",
    code: "SM",
  },
  {
    label: "Sao Tome and Principe",
    value: "+239",
    code: "ST",
  },
  {
    label: "Saudi Arabia",
    value: "+966",
    code: "SA",
  },
  {
    label: "Senegal",
    value: "+221",
    code: "SN",
  },
  {
    label: "Serbia",
    value: "+381",
    code: "RS",
  },
  {
    label: "Seychelles",
    value: "+248",
    code: "SC",
  },
  {
    label: "Sierra Leone",
    value: "+232",
    code: "SL",
  },
  {
    label: "Singapore",
    value: "+65",
    code: "SG",
  },
  {
    label: "Slovakia",
    value: "+421",
    code: "SK",
  },
  {
    label: "Slovenia",
    value: "+386",
    code: "SI",
  },
  {
    label: "Solomon Islands",
    value: "+677",
    code: "SB",
  },
  {
    label: "Somalia",
    value: "+252",
    code: "SO",
  },
  {
    label: "South Africa",
    value: "+27",
    code: "ZA",
  },
  {
    label: "South Sudan",
    value: "+211",
    code: "SS",
  },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "+500",
    code: "GS",
  },
  {
    label: "Spain",
    value: "+34",
    code: "ES",
  },
  {
    label: "Sri Lanka",
    value: "+94",
    code: "LK",
  },
  {
    label: "Sudan",
    value: "+249",
    code: "SD",
  },
  {
    label: "Suriname",
    value: "+597",
    code: "SR",
  },
  {
    label: "Svalbard and Jan Mayen",
    value: "+47",
    code: "SJ",
  },
  {
    label: "Swaziland",
    value: "+268",
    code: "SZ",
  },
  {
    label: "Sweden",
    value: "+46",
    code: "SE",
  },
  {
    label: "Switzerland",
    value: "+41",
    code: "CH",
  },
  {
    label: "Syrian Arab Republic",
    value: "+963",
    code: "SY",
  },
  {
    label: "Taiwan",
    value: "+886",
    code: "TW",
  },
  {
    label: "Tajikistan",
    value: "+992",
    code: "TJ",
  },
  {
    label: "Tanzania, United Republic of Tanzania",
    value: "+255",
    code: "TZ",
  },
  {
    label: "Thailand",
    value: "+66",
    code: "TH",
  },
  {
    label: "Timor-Leste",
    value: "+670",
    code: "TL",
  },
  {
    label: "Togo",
    value: "+228",
    code: "TG",
  },
  {
    label: "Tokelau",
    value: "+690",
    code: "TK",
  },
  {
    label: "Tonga",
    value: "+676",
    code: "TO",
  },
  {
    label: "Trinidad and Tobago",
    value: "+1868",
    code: "TT",
  },
  {
    label: "Tunisia",
    value: "+216",
    code: "TN",
  },
  {
    label: "Turkey",
    value: "+90",
    code: "TR",
  },
  {
    label: "Turkmenistan",
    value: "+993",
    code: "TM",
  },
  {
    label: "Turks and Caicos Islands",
    value: "+1649",
    code: "TC",
  },
  {
    label: "Tuvalu",
    value: "+688",
    code: "TV",
  },
  {
    label: "Uganda",
    value: "+256",
    code: "UG",
  },
  {
    label: "Ukraine",
    value: "+380",
    code: "UA",
  },
  {
    label: "United Arab Emirates",
    value: "+971",
    code: "AE",
  },
  {
    label: "United Kingdom",
    value: "+44",
    code: "GB",
  },
  {
    label: "United States",
    value: "+1",
    code: "US",
  },
  {
    label: "Uruguay",
    value: "+598",
    code: "UY",
  },
  {
    label: "Uzbekistan",
    value: "+998",
    code: "UZ",
  },
  {
    label: "Vanuatu",
    value: "+678",
    code: "VU",
  },
  {
    label: "Venezuela, Bolivarian Republic of Venezuela",
    value: "+58",
    code: "VE",
  },
  {
    label: "Vietnam",
    value: "+84",
    code: "VN",
  },
  {
    label: "Virgin Islands, British",
    value: "+1284",
    code: "VG",
  },
  {
    label: "Virgin Islands, U.S.",
    value: "+1340",
    code: "VI",
  },
  {
    label: "Wallis and Futuna",
    value: "+681",
    code: "WF",
  },
  {
    label: "Yemen",
    value: "+967",
    code: "YE",
  },
  {
    label: "Zambia",
    value: "+260",
    code: "ZM",
  },
  {
    label: "Zimbabwe",
    value: "+263",
    code: "ZW",
  },
];

const languageData = [
  {
    label: "Abkhaz",
    value: "Abkhaz",
  },
  {
    label: "Afar",
    value: "Afar",
  },
  {
    label: "Afrikaans",
    value: "Afrikaans",
  },
  {
    label: "Akan",
    value: "Akan",
  },
  {
    label: "Albanian",
    value: "Albanian",
  },
  {
    label: "Amharic",
    value: "Amharic",
  },
  {
    label: "Arabic",
    value: "Arabic",
  },
  {
    label: "Aragonese",
    value: "Aragonese",
  },
  {
    label: "Armenian",
    value: "Armenian",
  },
  {
    label: "Assamese",
    value: "Assamese",
  },
  {
    label: "Avaric",
    value: "Avaric",
  },
  {
    label: "Avestan",
    value: "Avestan",
  },
  {
    label: "Aymara",
    value: "Aymara",
  },
  {
    label: "Azerbaijani",
    value: "Azerbaijani",
  },
  {
    label: "Bambara",
    value: "Bambara",
  },
  {
    label: "Bashkir",
    value: "Bashkir",
  },
  {
    label: "Basque",
    value: "Basque",
  },
  {
    label: "Belarusian",
    value: "Belarusian",
  },
  {
    label: "Bengali",
    value: "Bengali",
  },
  {
    label: "Bihari",
    value: "Bihari",
  },
  {
    label: "Bislama",
    value: "Bislama",
  },
  {
    label: "Bosnian",
    value: "Bosnian",
  },
  {
    label: "Breton",
    value: "Breton",
  },
  {
    label: "Bulgarian",
    value: "Bulgarian",
  },
  {
    label: "Burmese",
    value: "Burmese",
  },
  {
    label: "Catalan; Valencian",
    value: "Catalan; Valencian",
  },
  {
    label: "Chamorro",
    value: "Chamorro",
  },
  {
    label: "Chechen",
    value: "Chechen",
  },
  {
    label: "Chichewa; Chewa; Nyanja",
    value: "Chichewavalue Chewa; Nyanja",
  },
  {
    label: "Chinese",
    value: "Chinese",
  },
  {
    label: "Chuvash",
    value: "Chuvash",
  },
  {
    label: "Cornish",
    value: "Cornish",
  },
  {
    label: "Corsican",
    value: "Corsican",
  },
  {
    label: "Cree",
    value: "Cree",
  },
  {
    label: "Croatian",
    value: "Croatian",
  },
  {
    label: "Czech",
    value: "Czech",
  },
  {
    label: "Danish",
    value: "Danish",
  },
  {
    label: "Divehi; Dhivehi; Maldivian;",
    value: "Divehivalue Dhivehi; Maldivian;",
  },
  {
    label: "Dutch",
    value: "Dutch",
  },
  {
    label: "English",
    value: "English",
  },
  {
    label: "Esperanto",
    value: "Esperanto",
  },
  {
    label: "Estonian",
    value: "Estonian",
  },
  {
    label: "Ewe",
    value: "Ewe",
  },
  {
    label: "Faroese",
    value: "Faroese",
  },
  {
    label: "Fijian",
    value: "Fijian",
  },
  {
    label: "Finnish",
    value: "Finnish",
  },
  {
    label: "French",
    value: "French",
  },
  {
    label: "Fula; Fulah; Pulaar; Pular",
    value: "Fula; Fulahvalue Pulaar; Pular",
  },
  {
    label: "Galician",
    value: "Galician",
  },
  {
    label: "Georgian",
    value: "Georgian",
  },
  {
    label: "German",
    value: "German",
  },
  {
    label: "Greek, Modern",
    value: "Greek, Modern",
  },
  {
    label: "Guaraní",
    value: "Guaraní",
  },
  {
    label: "Gujarati",
    value: "Gujarati",
  },
  {
    label: "Haitian; Haitian Creole",
    label: "value; Haitian Creole",
  },
  {
    label: "Hausa",
    value: "Hausa",
  },
  {
    label: "Hebrew",
    value: "Hebrew",
  },
  {
    label: "Hebrew",
    value: "Hebrew",
  },
  {
    label: "Herero",
    value: "Herero",
  },
  {
    label: "Hindi",
    value: "Hindi",
  },
  {
    label: "Hiri Motu",
    value: "Hiri Motu",
  },
  {
    label: "Hungarian",
    value: "Hungarian",
  },
  {
    label: "Interlingua",
    value: "Interlingua",
  },
  {
    label: "Indonesian",
    value: "Indonesian",
  },
  {
    label: "Interlingue",
    value: "Interlingue",
  },
  {
    label: "Irish",
    value: "Irish",
  },
  {
    label: "Igbo",
    value: "Igbo",
  },
  {
    label: "Inupiaq",
    value: "Inupiaq",
  },
  {
    label: "Ido",
    value: "Ido",
  },
  {
    label: "Icelandic",
    value: "Icelandic",
  },
  {
    label: "Italian",
    value: "Italian",
  },
  {
    label: "Inuktitut",
    value: "Inuktitut",
  },
  {
    label: "Japanese",
    value: "Japanese",
  },
  {
    label: "Javanese",
    value: "Javanese",
  },
  {
    label: "Kalaallisut, Greenlandic",
    value: "Kalaallisut, Greenlandic",
  },
  {
    label: "Kannada",
    value: "Kannada",
  },
  {
    label: "Kanuri",
    value: "Kanuri",
  },
  {
    label: "Kashmiri",
    value: "Kashmiri",
  },
  {
    label: "Kazakh",
    value: "Kazakh",
  },
  {
    label: "Khmer",
    value: "Khmer",
  },
  {
    label: "Kikuyu, Gikuyu",
    value: "Kikuyu, Gikuyu",
  },
  {
    label: "Kinyarwanda",
    value: "Kinyarwanda",
  },
  {
    label: "Kirghiz, Kyrgyz",
    value: "Kirghiz, Kyrgyz",
  },
  {
    label: "Komi",
    value: "Komi",
  },
  {
    label: "Kongo",
    value: "Kongo",
  },
  {
    label: "Korean",
    value: "Korean",
  },
  {
    label: "Kurdish",
    value: "Kurdish",
  },
  {
    label: "Kwanyama, Kuanyama",
    value: "Kwanyama, Kuanyama",
  },
  {
    label: "Latin",
    value: "Latin",
  },
  {
    label: "Luxembourgish, Letzeburgesch",
    value: "Luxembourgish, Letzeburgesch",
  },
  {
    label: "Luganda",
    value: "Luganda",
  },
  {
    label: "Limburgish, Limburgan, Limburger",
    value: "Limburgishvalue Limburgan, Limburger",
  },
  {
    label: "Lingala",
    value: "Lingala",
  },
  {
    label: "Lao",
    value: "Lao",
  },
  {
    label: "Lithuanian",
    value: "Lithuanian",
  },
  {
    label: "Luba-Katanga",
    value: "Luba-Katanga",
  },
  {
    label: "Latvian",
    value: "Latvian",
  },
  {
    label: "Manx",
    value: "Manx",
  },
  {
    label: "Macedonian",
    value: "Macedonian",
  },
  {
    label: "Malagasy",
    value: "Malagasy",
  },
  {
    label: "Malay",
    value: "Malay",
  },
  {
    label: "Malayalam",
    value: "Malayalam",
  },
  {
    label: "Maltese",
    value: "Maltese",
  },
  {
    label: "Māori",
    value: "Māori",
  },
  {
    label: "Marathi (Marāṭhī)",
    value: "Marathi (Marāṭhī)",
  },
  {
    label: "Marshallese",
    value: "Marshallese",
  },
  {
    label: "Mongolian",
    value: "Mongolian",
  },
  {
    label: "Nauru",
    value: "Nauru",
  },
  {
    label: "Navajo, Navaho",
    value: "Navajo, Navaho",
  },
  {
    label: "Norwegian Bokmål",
    value: "Norwegian Bokmål",
  },
  {
    label: "North Ndebele",
    value: "North Ndebele",
  },
  {
    label: "Nepali",
    value: "Nepali",
  },
  {
    label: "Ndonga",
    value: "Ndonga",
  },
  {
    label: "Norwegian Nynorsk",
    value: "Norwegian Nynorsk",
  },
  {
    label: "Norwegian",
    value: "Norwegian",
  },
  {
    label: "Nuosu",
    value: "Nuosu",
  },
  {
    label: "South Ndebele",
    value: "South Ndebele",
  },
  {
    label: "Occitan",
    value: "Occitan",
  },
  {
    label: "Ojibwe, Ojibwa",
    value: "Ojibwe, Ojibwa",
  },
  {
    label:
      "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    value:
      "Old Church Slavonic, Church Slavic, Church Slavonic, Old value, Old Slavonic",
  },
  {
    label: "Oromo",
    value: "Oromo",
  },
  {
    label: "Oriya",
    value: "Oriya",
  },
  {
    label: "Ossetian, Ossetic",
    value: "Ossetian, Ossetic",
  },
  {
    label: "Panjabi, Punjabi",
    value: "Panjabi, Punjabi",
  },
  {
    label: "Pāli",
    value: "Pāli",
  },
  {
    label: "Persian",
    value: "Persian",
  },
  {
    label: "Polish",
    value: "Polish",
  },
  {
    label: "Pashto, Pushto",
    value: "Pashto, Pushto",
  },
  {
    label: "Portuguese",
    value: "Portuguese",
  },
  {
    label: "Quechua",
    value: "Quechua",
  },
  {
    label: "Romansh",
    value: "Romansh",
  },
  {
    label: "Kirundi",
    value: "Kirundi",
  },
  {
    label: "Romanian, Moldavian, Moldovan",
    value: "Romanianvalue Moldavian, Moldovan",
  },
  {
    label: "Russian",
    value: "Russian",
  },
  {
    label: "Sanskrit (Saṁskṛta)",
    value: "Sanskrit (Saṁskṛta)",
  },
  {
    label: "Sardinian",
    value: "Sardinian",
  },
  {
    label: "Sindhi",
    value: "Sindhi",
  },
  {
    label: "Northern Sami",
    value: "Northern Sami",
  },
  {
    label: "Samoan",
    value: "Samoan",
  },
  {
    label: "Sango",
    value: "Sango",
  },
  {
    label: "Serbian",
    value: "Serbian",
  },
  {
    label: "Scottish Gaelic; Gaelic",
    label: "value Gaelic; Gaelic",
  },
  {
    label: "Shona",
    value: "Shona",
  },
  {
    label: "Sinhala, Sinhalese",
    value: "Sinhala, Sinhalese",
  },
  {
    label: "Slovak",
    value: "Slovak",
  },
  {
    label: "Slovene",
    value: "Slovene",
  },
  {
    label: "Somali",
    value: "Somali",
  },
  {
    label: "Southern Sotho",
    value: "Southern Sotho",
  },
  {
    label: "Spanish; Castilian",
    value: "Spanish; Castilian",
  },
  {
    label: "Sundanese",
    value: "Sundanese",
  },
  {
    label: "Swahili",
    value: "Swahili",
  },
  {
    label: "Swati",
    value: "Swati",
  },
  {
    label: "Swedish",
    value: "Swedish",
  },
  {
    label: "Tamil",
    value: "Tamil",
  },
  {
    label: "Telugu",
    value: "Telugu",
  },
  {
    label: "Tajik",
    value: "Tajik",
  },
  {
    label: "Thai",
    value: "Thai",
  },
  {
    label: "Tigrinya",
    value: "Tigrinya",
  },
  {
    label: "Tibetan Standard, Tibetan, Central",
    value: "Tibetan Standardvalue Tibetan, Central",
  },
  {
    label: "Turkmen",
    value: "Turkmen",
  },
  {
    label: "Tagalog",
    value: "Tagalog",
  },
  {
    label: "Tswana",
    value: "Tswana",
  },
  {
    label: "Tonga (Tonga Islands)",
    value: "(Tonga Islands)",
  },
  {
    label: "Turkish",
    value: "Turkish",
  },
  {
    label: "Tsonga",
    value: "Tsonga",
  },
  {
    label: "Tatar",
    value: "Tatar",
  },
  {
    label: "Twi",
    value: "Twi",
  },
  {
    label: "Tahitian",
    value: "Tahitian",
  },
  {
    label: "Uighur, Uyghur",
    value: "Uighur, Uyghur",
  },
  {
    label: "Ukrainian",
    value: "Ukrainian",
  },
  {
    label: "Urdu",
    value: "Urdu",
  },
  {
    label: "Uzbek",
    value: "Uzbek",
  },
  {
    label: "Venda",
    value: "Venda",
  },
  {
    label: "Vietnamese",
    value: "Vietnamese",
  },
  {
    label: "Volapük",
    value: "Volapük",
  },
  {
    label: "Walloon",
    value: "Walloon",
  },
  {
    label: "Welsh",
    value: "Welsh",
  },
  {
    label: "Wolof",
    value: "Wolof",
  },
  {
    label: "Western Frisian",
    value: "Western Frisian",
  },
  {
    label: "Xhosa",
    value: "Xhosa",
  },
  {
    label: "Yiddish",
    value: "Yiddish",
  },
  {
    label: "Yoruba",
    value: "Yoruba",
  },
  {
    label: "Zhuang, Chuang",
    value: "Zhuang, Chuang",
  },
];

let countyArray = [
  { label: "Bedfordshire", value: "Bedfordshire" },
  { label: "Buckinghamshire", value: "Buckinghamshire" },
  { label: "Cambridgeshire", value: "Cambridgeshire" },
  { label: "Cheshire", value: "Cheshire" },
  { label: "Cleveland", value: "Cleveland" },
  { label: "Cornwall", value: "Cornwall" },
  { label: "Cumbria", value: "Cumbria" },
  { label: "Derbyshire", value: "Derbyshire" },
  { label: "Devon", value: "Devon" },
  { label: "Dorset", value: "Dorset" },
  { label: "Durham", value: "Durham" },
  { label: "East Sussex", value: "East Sussex" },
  { label: "Essex", value: "Essex" },
  { label: "Gloucestershire", value: "Gloucestershire" },
  { label: "Greater London", value: "Greater London" },
  { label: "Greater Manchester", value: "Greater Manchester" },
  { label: "Hampshire", value: "Hampshire" },
  { label: "Hertfordshire", value: "Hertfordshire" },
  { label: "Kent", value: "Kent" },
  { label: "Lancashire", value: "Lancashire" },
  { label: "Leicestershire", value: "Leicestershire" },
  { label: "Lincolnshire", value: "Lincolnshire" },
  { label: "Merseyside", value: "Merseyside" },
  { label: "Norfolk", value: "Norfolk" },
  { label: "North Yorkshire", value: "North Yorkshire" },
  { label: "Northamptonshire", value: "Northamptonshire" },
  { label: "Northumberland", value: "Northumberland" },
  { label: "Nottinghamshire", value: "Nottinghamshire" },
  { label: "Oxfordshire", value: "Oxfordshire" },
  { label: "Shropshire", value: "Shropshire" },
  { label: "Somerset", value: "Somerset" },
  { label: "South Yorkshire", value: "South Yorkshire" },
  { label: "Staffordshire", value: "Staffordshire" },
  { label: "Suffolk", value: "Suffolk" },
  { label: "Surrey", value: "Surrey" },
  { label: "Tyne and Wear", value: "Tyne and Wear" },
  { label: "Warwickshire", value: "Warwickshire" },
  { label: "West Berkshire", value: "West Berkshire" },
  { label: "West Midlands", value: "West Midlands" },
  { label: "West Sussex", value: "West Sussex" },
  { label: "West Yorkshire", value: "West Yorkshire" },
  { label: "Wiltshire", value: "Wiltshire" },
  { label: "Worcestershire", value: "Worcestershire" },
  { label: "Flintshire", value: "Flintshire" },
  { label: "Glamorgan", value: "Glamorgan" },
  { label: "Merionethshire", value: "Merionethshire" },
  { label: "Monmouthshire", value: "Monmouthshire" },
  { label: "Montgomeryshire", value: "Montgomeryshire" },
  { label: "Pembrokeshire", value: "Pembrokeshire" },
  { label: "Radnorshire", value: "Radnorshire" },
  { label: "Anglesey", value: "Anglesey" },
  { label: "Breconshire", value: "Breconshire" },
  { label: "Caernarvonshire", value: "Caernarvonshire" },
  { label: "Cardiganshire", value: "Cardiganshire" },
  { label: "Carmarthenshire", value: "Carmarthenshire" },
  { label: "Denbighshire", value: "Denbighshire" },
  { label: "Aberdeen City", value: "Aberdeen City" },
  { label: "Aberdeenshire", value: "Aberdeenshire" },
  { label: "Angus", value: "Angus" },
  { label: "Argyll and Bute", value: "Argyll and Bute" },
  { label: "City of Edinburgh", value: "City of Edinburgh" },
  { label: "Clackmannanshire", value: "Clackmannanshire" },
  { label: "Dumfries and Galloway", value: "Dumfries and Galloway" },
  { label: "Dundee City", value: "Dundee City" },
  { label: "East Ayrshire", value: "East Ayrshire" },
  { label: "East Dunbartonshire", value: "East Dunbartonshire" },
  { label: "East Lothian", value: "East Lothian" },
  { label: "East Renfrewshire", value: "East Renfrewshire" },
  { label: "Eilean Siar", value: "Eilean Siar" },
  { label: "Falkirk", value: "Falkirk" },
  { label: "Fife", value: "Fife" },
  { label: "Glasgow City", value: "Glasgow City" },
  { label: "Highland", value: "Highland" },
  { label: "Inverclyde", value: "Inverclyde" },
  { label: "Midlothian", value: "Midlothian" },
  { label: "Moray", value: "Moray" },
  { label: "North Ayrshire", value: "North Ayrshire" },
  { label: "North Lanarkshire", value: "North Lanarkshire" },
  { label: "Orkney Islands", value: "Orkney Islands" },
  { label: "Perth and Kinross", value: "Perth and Kinross" },
  { label: "Renfrewshire", value: "Renfrewshire" },
  { label: "Scottish Borders", value: "Scottish Borders" },
  { label: "Shetland Islands", value: "Shetland Islands" },
  { label: "South Ayrshire", value: "South Ayrshire" },
  { label: "South Lanarkshire", value: "South Lanarkshire" },
  { label: "Stirling", value: "Stirling" },
  { label: "West Dunbartonshire", value: "West Dunbartonshire" },
  { label: "West Lothian", value: "West Lothian" },
  { label: "Antrim", value: "Antrim" },
  { label: "Armagh", value: "Armagh" },
  { label: "Down", value: "Down" },
  { label: "Fermanagh", value: "Fermanagh" },
  { label: "Derry and Londonderry", value: "Derry and Londonderry" },
  { label: "Tyrone", value: "Tyrone" },
];
export { countryCodeArray, languageData, countyArray };
